import React, { Component } from "react";
import { Dropdown } from "semantic-ui-react";
import axios from "axios";
import { connect } from "react-redux";
import _ from "lodash";
import { setReportState, setReportDppa } from "../../actions/dppaAndState";
import settings, { getApiHost } from "../../settings";
import InlineError from "../messages/InlineError";
import DppaUse from "../dialogs/DppaUse";

class DppaSelection extends Component {
  constructor(props) {
    super(props);
    let cancelStateTokenSource;
    let cancelDppaTokenSource;
    let dppaOptions = [];
    let searchStateOptions = [];
    this.dppaRef = React.createRef();
    this.dppaStateRef = React.createRef();
    if (!props.dppaAndState) {
      cancelStateTokenSource = axios.CancelToken.source();
      axios
        .post(
          `${getApiHost(settings.env)}/states.aspx`,
          {
            appName: settings.appName,
          },
          { async: false }
        )
        .then((res) => {
          if (res.status === 200) {
            const options = [];
            options.push({
              key: "-1",
              value: "-1",
              text: "Select State",
            });
            _.map(res.data.Data, (state) => {
              options.push({
                key: state.StateCode,
                value: state.StateCode,
                text: state.StateDesc,
              });
            });
            this.props.setReportState(options);
            this.setState({
              searchStateOptions: options,
              cancelStateTokenSource: undefined,
            });
          }
        })
        .catch((err) => {
          console.log("dpp state cancel error", err);
          this.setState({ cancelStateTokenSource: undefined });
        });
      cancelDppaTokenSource = axios.CancelToken.source();
      axios
        .post(
          `${getApiHost(settings.env)}/dppa.aspx`,
          {
            appName: settings.appName,
          },
          { async: false }
        )
        .then((res) => {
          if (res.status === 200) {
            dppaOptions.push({
              key: "-1",
              value: "-1",
              text: "Not Selected",
            });
            _.map(res.data.Data, (dppa, index) => {
              dppaOptions.push({
                key: dppa.DiscDesc,
                value: index + 1,
                // value: dppa.DiscId,
                text: dppa.DiscDesc,
              });
            });
            const options = [];
            _.map(res.data.Data, (dppa, index) => {
              options.push({
                key: dppa.DiscDesc,
                value: index + 1,
                text: dppa.DiscDesc,
                disc: dppa.DiscWording,
              });
            });
            this.props.setReportDppa(dppaOptions);
            this.setState({
              options,
              dppaOptions,
              cancelDppaTokenSource: undefined,
            });
          }
        })
        .catch((err) => {
          console.log("dpp cancel error", err);
          this.setState({ cancelDppaTokenSource: undefined });
        });
    } else {
      if (props.dppaAndState.dppa) dppaOptions = props.dppaAndState.dppa;
      if (props.dppaAndState.state)
        searchStateOptions = props.dppaAndState.state;
    }
    this.state = {
      searchStateOptions,
      dppaOptions,
      cancelStateTokenSource,
      cancelDppaTokenSource,
      active: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.dppaAndState &&
      this.state.dppaOptions.length === 0 &&
      !nextProps.dppaAndState
    ) {
      this.setState({
        searchStateOptions: nextProps.dppaAndState.state,
        dppaOptions: nextProps.dppaAndState.dppa,
      });
    }
    if (nextProps.errors) {
      if (nextProps.errors.dppa) {
        setTimeout(() => {
          this.dppaRef.current.toggle();
        }, 100);
      } else if (nextProps.errors.userPickedState) {
        setTimeout(() => {
          this.dppaStateRef.current.toggle();
        }, 100);
      }
    }
  }

  componentWillUnmount() {
    if (this.state.cancelStateTokenSource !== undefined) {
      this.state.cancelStateTokenSource.cancel("Dppa state unmounting...");
    }
    if (this.state.cancelDppaTokenSource !== undefined) {
      this.state.cancelDppaTokenSource.cancel("Dppa unmounting...");
    }
  }

  onDppaChange = (e, data, controlId) => {
    this.props.onDppaUseChange(controlId, data.value);
  };

  onSearchStateChange = (e, data, controlId) => {
    this.props.onDppaStateChange(controlId, data.value);
  };

  closeDppaDialog = () => this.setState({ active: false });

  showDppaUse = () => {
    if (!this.state.active) this.setState({ active: true });
  };

  render() {
    const { userAccount } = this.props;
    return (
      <div className={userAccount.acctTheme === 0 ? "selectedMVRDIV" : ""}>
        <span
          className={
            userAccount.acctTheme === 0
              ? "text-center addon-dppa"
              : "text-center"
          }
        >
          Please select a DPPA use and State
        </span>
        <div>
          <DppaUse
            active={this.state.active}
            closeDppaDialog={this.closeDppaDialog}
            dppas={this.state.options}
          />
          <span
            role={"button"}
            tabIndex={-1}
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={() => this.showDppaUse()}
          >
            DPPA use:{" "}
          </span>
          <Dropdown
            fluid
            search
            selectOnBlur={false}
            selection
            key={`Dppa_${this.props.reportName}`}
            id={`Dppa_${this.props.reportName}_${this.props.controlId}`}
            options={this.state.dppaOptions}
            name={`Dppa_${this.props.reportName}`}
            defaultValue={"-1"}
            // value={this.props.selData.dppa}
            onChange={(e, data) =>
              this.onDppaChange(e, data, this.props.controlId)
            }
            ref={this.dppaRef}
          />
          {this.props.errors.dppa !== undefined ? (
            <InlineError text={this.props.errors.dppa} />
          ) : null}
        </div>
        <div className={"padding-bottom-10"}>
          <span>State: </span>
          <Dropdown
            fluid
            search
            selectOnBlur={false}
            selection
            key={`State_${this.props.reportName}`}
            id={`State_${this.props.reportName}_${this.props.controlId}`}
            options={this.state.searchStateOptions}
            name={`State_${this.props.reportName}`}
            defaultValue={"-1"}
            // value={this.props.selData.userPickedState}
            onChange={(e, data) =>
              this.onSearchStateChange(e, data, this.props.controlId)
            }
            ref={this.dppaStateRef}
          />
          {this.props.errors.userPickedState !== undefined ? (
            <InlineError text={this.props.errors.userPickedState} />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dppaAndState:
      !state.dppaAndState || Object.keys(state.dppaAndState).length < 1
        ? undefined
        : state.dppaAndState.dppaAndState,
  };
}

export default connect(mapStateToProps, { setReportState, setReportDppa })(
  DppaSelection
);



// WEBPACK FOOTER //
// ./src/components/searchresults/DppaSelection.js